import Vue from "vue";
import { vuexfireMutations } from "vuexfire";
import Vuex from "vuex";
import { db, storage } from "@/config/firebaseInit";

Vue.use(Vuex);
import createPersistedState from "vuex-persistedstate";

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    clear: null,
    user: null,
    user_id: null,
    phase: "Application Approval",
    application_approval_phase: null,
    application_approval_step: null,
    soft_underwriting_phase: null,
    final_underwriting_phase: null,
    funding_gate_phase: "start",
    answers: null,
    progress: 0,
    tempId: null,
  },
  getters: {},
  mutations: {
    stopClear(state) {
      state.clear = true;
    },
    setUserId(state) {
      if (!state.user_id) {
        state.user_id = db.collection("user").doc().id;
      }
    },
    setNewUser(state, user) {
      state.user_id = user.id;
      state.user = user;
    },
    setUser(state, user) {
      if (state.user) {
        user = Object.assign(state.user, user);
      } else {
        state.user = user;
      }
    },
    clearUser(state) {
      state.user = null;
      state.application_approval_phase = "start";
      state.application_approval_step = 1;
      state.user_id = null;
      state.application_approval_progress = 0;
    },
    setAnswers(state, answers) {
      if (state.answers) {
        if (answers) answers = Object.assign(state.answers, answers);
      }
      state.answers = answers;
    },
    setApplicationApprovalPhase(state, phase) {
      state.application_approval_phase = phase;
    },
    setApplicationApprovalStep(state, step) {
      state.application_approval_step = step;
    },
    setSoftUnderwritingPhase(state, phase) {
      state.soft_underwriting_phase = phase;
    },
    setFinalUnderwritingPhase(state, phase) {
      state.final_underwriting_phase = phase;
    },
    setFundingGatePhase(state, phase) {
      state.funding_gate_phase = phase;
    },
    setApplicationApprovalProgress(state, progress) {
      state.user.progress = Math.floor(progress);
    },
    setPhase(state, phase) {
      state.phase = phase;
    },
    setProgress(state, progress) {
      state.progress = progress;
    },
    setTempId(state, id) {
      state.tempId = id;
    },
  },
  actions: {
    signOut(context) {
      context.commit("clearUser");
    },
  },
});
